import { labelSlotClass } from '../labelSlots';
import type { LabelColor } from '@/lib/api/generated/model';

export interface LabelSwatchProps {
  color: LabelColor;
  /** Extra classes for the caller's layout — size and shape stay here. */
  className?: string;
}

/**
 * One slot's colour, with no name on it.
 *
 * This exists so that choosing a colour does not require reaching for
 * `labelSlotClass`, which the package withholds on purpose: a caller holding
 * the class is a caller about to build a second chip, and two chips drift. The
 * settings picker is the one legitimate caller that needs the colour *without*
 * the label — it is showing eight colours to choose between, not eight labels.
 *
 * Deliberately `aria-hidden`. A swatch is a colour and colours have no accessible
 * name worth inventing — "a pale green square" tells a screen reader nothing
 * about which slot it is. The caller names the control it sits inside, which is
 * also what serves anyone who cannot separate these hues.
 */
export function LabelSwatch({ color, className = '' }: LabelSwatchProps) {
  return (
    <span
      aria-hidden="true"
      data-slot="label-swatch"
      className={`block size-6 rounded-md ${labelSlotClass(color)} ${className}`}
    />
  );
}
